import { render, staticRenderFns } from "./KeyStats.vue?vue&type=template&id=2a8156dc&scoped=true&"
import script from "./KeyStats.vue?vue&type=script&lang=js&"
export * from "./KeyStats.vue?vue&type=script&lang=js&"
import style0 from "./KeyStats.vue?vue&type=style&index=0&id=2a8156dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8156dc",
  null
  
)

export default component.exports